import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, filter } from 'rxjs';
import { io } from "socket.io-client";
import { AuthenticationService } from '../shared/services/authentication.service';
import { environment } from '../../../../../public/environments/environment';


export enum SocketEventType {
  Notification = "notification",
  EndAiInterview = "end-interview",
}


interface SocketEvent<TDataShape> {
  type: SocketEventType,
  data?: any
}


@Injectable({
  providedIn: 'root'
})
export class SocketService {

  socket: any;
  token!: string;
  private socketEvent!: Subject<any>;

  public message$: BehaviorSubject<string> = new BehaviorSubject('');
  private ListOfListener: string[] = [];

  constructor(
    private _authService: AuthenticationService
  ) {
    this.socketEvent = new Subject<any>();

  }


  onOpenSocket() {
    this.token = localStorage.getItem('token') || '';


    this.socket = io(environment.socketUrl, {
      transports: ['websocket'],
      auth: {
        token: `${this.token}`,
      }
    });
  }

  onCloseSocket() {
    this.socket.disconnect();
    this.socket.close();
  }


  setupSocketEvents() {
    this.socket?.on('connect', (data: any) => {
      // console.log("Socket ID is: " + this.socket.id);
      // this.RegisterToSocket(this.socket.id);

      this.socket?.on(SocketEventType.Notification, (data: any) => {
        this.onMessage({ type: SocketEventType.Notification, data });
      });

      this.socket?.on(SocketEventType.EndAiInterview, (data: any) => {
        this.onMessage({ type: SocketEventType.EndAiInterview, data });
      });
    })
  }

  // public sendMessage(message:any) {
  //   this.socket.emit('message', message);
  // }

  // public getNewMessage = () => {
  //   this.socket.on('message', (message) =>{
  //     this.message$.next(message);
  //   });

  //   return this.message$.asObservable();
  // };

  private onMessage<TDataShape>(payload: SocketEvent<TDataShape>) {
    this.socketEvent.next(payload);
  }

  getDataStream<TDataShape>(type: SocketEventType | string): Observable<SocketEvent<TDataShape>> {
    return this.socketEvent.asObservable().pipe(filter(event => type === event.type))
  }


  RegisterToSocket(socketId: string) {
    // let my = macadress
    // my.one(function (err, mac) {
    //   console.log("Mac address for this host: %s", mac);
    // });
    const model = {
      type: "web",
      socket_id: socketId,
      mac_address: (Math.random() * 1000000000000000).toString()
    }
    this._authService.ConnectToSocket(model).subscribe((response) => {
      console.log("Clinet registered successfully", response);
    })
  }
}
